import { isArray, uniqueId } from "lodash-es";
import React, { ReactNode } from "react";

import { ITestable } from "@/browser";

import { IBlurable, IChangeable } from "../../Form";
import { IUploadData } from "./types";

const getUniqueKey = () => {
  return uniqueId("file-");
};

interface Methods {
  onFileChange: (file?: File | File[] | null) => void;
  onFileBlur: () => void;
}

interface State extends Methods {
  value?: IUploadData | any;
}

export interface IFileUploadRenderProps extends Methods, ITestable {
  value?: IUploadData | any;
  invalid?: boolean;
}

interface Props extends IChangeable, IBlurable, ITestable {
  children: (value: IFileUploadRenderProps) => ReactNode;
  invalid?: boolean;
}

export class FileUpload extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      value: this.props.value ? this.createOnlyAttachment(this.props.value) : undefined,
      onFileChange: this.onFileChange,
      onFileBlur: this.onFileBlur,
    };
  }

  handleChange = (value?: any) => {
    const { onChange } = this.props;

    if (onChange) {
      onChange(value);
    }
  };

  onFileChange = (value?: File | File[] | null) => {
    if (isArray(value)) {
      throw new Error("Only single file allowed. Use FilesUpload components instead");
    }

    if (value) {
      this.setState({ value: this.createOnlyFile(value) });
    }
  };

  onFileBlur = () => {
    const { onBlur } = this.props;

    if (onBlur) {
      onBlur();
    }
  };

  createOnlyFile = (file: File): IUploadData => {
    const key = getUniqueKey();
    return { key, file, onUpload: this.onUpload, onRemove: this.onRemove };
  };

  createOnlyAttachment = (attachment: any, key = getUniqueKey()): IUploadData => {
    return { key, attachment, onRemove: this.onRemove };
  };

  onUpload = (attachment: any) => {
    this.setState({ value: this.createOnlyAttachment(attachment) }, () => this.handleChange(attachment));
  };

  onRemove = (defaultValue?: any) => {
    this.setState({ value: undefined }, () => this.handleChange(defaultValue));
  };

  render() {
    const { children, invalid, testName } = this.props;

    return children({ ...this.state, invalid, testName });
  }
}
